/* eslint-disable no-unused-vars */
/** @module Auth0PreLoginHandlerSmsCollection */
/* eslint-disable import/extensions */
import Auth0PreLoginHandlerBase from '../auth0-pre-login-handler-base.mst.mjs';
import Auth0SmsCollectionHelper from '../../../pages/auth0-sms-collection.mst.mjs';

class Auth0PreLoginHandlerSmsCollection extends Auth0PreLoginHandlerBase {
  _shouldHandleSync = () => {
    return !!this._qs.get('collect_sms');
  };

  /**
   * @inheritdoc
   */
  async shouldHandle() {
    return Promise.resolve(this._shouldHandleSync());
  }

  /**
   * @inheritdoc
   */
  async run(viewOptions = {}) {
    console.log('Auth0PreLoginHandlerSmsCollection.run() starting');
    const userMfaChoiceRequired = this._qs.get('user_choice_required') === 'true';

    await new Auth0SmsCollectionHelper({
      grantToken: this._qs.get('session_token'),
      uriState: this._qs.get('state'),
      name: 'Auth0MfaCodePageHelper',
      tenantOrDomain: this._tenant.id,
      whiteLabelOptions: this._whiteLabelOptions,
      appLoginUrl: this._appLoginUrl,
      clientId: this._clientId,
      userMfaChoiceRequired,
    }).render();

    return true;
  }
}

export default Auth0PreLoginHandlerSmsCollection;
